import { render, staticRenderFns } from "./accountBD.vue?vue&type=template&id=5576d6d5"
import script from "./accountBD.vue?vue&type=script&lang=js"
export * from "./accountBD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports